import React from 'react'
import { Spinner, Icon } from 'react-mdl'

export default function SavingIndicator({ saved, error }) {
  return saved === 'saving'
    ? <Spinner />
    : <Icon
        name={error ? 'cloud_off' : saved ? 'cloud_done' : 'cloud_queue'}
        style={{
          color: error ? 'red' : saved ? 'green' : 'orange',
        }}
      />
}



// WEBPACK FOOTER //
// ./src/components/SavingIndicator.js